// extracted by mini-css-extract-plugin
module.exports = {"button":"styles_button__2K1Iu","buttonText":"styles_buttonText__3lUp7","buttonArrow":"styles_buttonArrow__1qyM6","highlight":"styles_highlight__kdrp9"};